// If the link is a hash link or a klipfolio link, open in the same tab
export function isSameTab(link) {
  return link?.startsWith("#") || link?.includes("klipfolio.com")
}
